import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import "./map/china.js"
import "@/reset/reset.css"
import 'swiper/css/swiper.min.css';
import 'swiper/js/swiper.min.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// console.log(ElementUI)
Vue.use(ElementUI);
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
